export default function resolveCustomerDisplayName(customer) {
  if (!customer) return '';
  if (customer.full_names) return customer.full_names;
  return `${customer.last_name || ''} ${customer.first_name || ''}`.trim();
}
